/**
 * @Description 区域保护顶部
 */
import { FC, useMemo, useRef, useState } from 'react';
import V2Title from '../../../Feedback/V2Title';
import V2Operate from '../../../Others/V2Operate';
import { useMethods } from '@lhb/hook';
import ApprovalCreateDialog from '@/common/components/business/ExpandStore/ApprovalCreateDialog';
import { refactorPermissions } from '@lhb/func';
import { V2Confirm } from '@/common/components/Others/V2Confirm';
import { approvalReboot, chancePointProtect } from '@/common/api/expandStore/approveworkbench';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { ApprovalType, ApprovalTypeValue } from '../../ExpandStore/ts-config';

const Title:FC<any> = ({
  // approvalPermissions,
  isReject,
  approvalId,
  conflictInfo,
  setOpen,
  onComplete,
  id,
  approvalDetail,
  isMKD
}) => {
  const [approvalVisible, setApprovalVisible] = useState<boolean>(false);
  const lockRef: any = useRef(false);


  // 申请前，由前端控制按钮（取消、提交审批、特殊申请），申请后由服务端控制
  const operateList:any = useMemo(() => {
    // 是否冲突
    const isConflict = conflictInfo?.conflictRegionItemResponseList?.length;
    if (isReject) {
      return [
        { name: '重新提交', event: 'reboot', type: 'primary', }
      ];
    }
    // 如果关闭区域保护，则没有按钮,或者审批中
    if (!conflictInfo?.openFlag || approvalId) {
      return [];
    }
    // 摩卡多租户在冲突的场景下隐藏特殊申请按钮
    if (isConflict && isMKD) {
      return [
        {
          name: '取消',
          event: 'feCancel',
          type: 'default',
        },
      ];
    }
    return [
      {
        name: '取消',
        event: 'feCancel',
        type: 'default',
      },
      {
        name: `${isConflict ? '特殊申请' : '确定保护'}`,
        event: 'feConfirm',
        type: 'primary',
      }
    ];
  }, [conflictInfo, approvalId, isReject, isMKD]);
  const methods = useMethods({
    handleFeCancel() {
      setOpen?.(false);
    },
    handleFeConfirm() {
      if (conflictInfo?.conflictRegionItemResponseList?.length) {
        setApprovalVisible(true);
        return;
      }
      if (lockRef.current) return;
      lockRef.current = true;
      chancePointProtect({ id }).then(() => {
        V2Message.success('区域保护成功，可以进行下一步操作！');
        setOpen?.(false);
        onComplete?.();
      }).finally(() => {
        lockRef.current = false;
      });
    },
    // 重新提交
    handleReboot() {
      V2Confirm({
        content: `确定要重新提交`,
        onSure() {
          approvalReboot({ id: approvalId }).then(() => { // 暂时不支持-添加自选节点
            V2Message.success('重新提交成功');
            setOpen?.(false);
            onComplete?.();
          });
        }
      });
    },
  });

  return <div>
    <V2Title
      text={approvalDetail?.name ||
        `${conflictInfo?.branchCompanyName || ''}${conflictInfo?.name || ''}区域保护申请`}
      extra={<V2Operate
        operateList={refactorPermissions(operateList)}
        onClick={(btn) => methods[btn.func]()}
      />}
    ></V2Title>
    {/* 提交审批 */}
    <ApprovalCreateDialog
      visible={approvalVisible}
      setVisible={setApprovalVisible}
      id={id}
      type={ApprovalType.ShopProtect}
      typeValue={ApprovalTypeValue.ShopProtect}
      onComplete={() => {
        setOpen?.(false);
        onComplete?.();
      }}
    />
  </div>;
};
export default Title;
